import { render, staticRenderFns } from "./OfficeElement.vue?vue&type=template&id=3325045a&scoped=true&"
import script from "./OfficeElement.vue?vue&type=script&lang=ts&"
export * from "./OfficeElement.vue?vue&type=script&lang=ts&"
import style0 from "./OfficeElement.vue?vue&type=style&index=0&id=3325045a&lang=scss&scoped=true&"
import style1 from "./OfficeElement.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3325045a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
